// extracted by mini-css-extract-plugin
export default {"imageWrap":"About_imageWrap__y4Cqc","image":"About_image__47cfB"};